module.exports = __webpack_public_path__ + "img/anchor.6ab4c8ff.png";